import React, {Component} from "react"
import PropTypes from "prop-types"

export default class SingleChoice extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  _handleChange(e) {
    const {question, onChange} = this.props

    // uuids must be prefixed with "question_"
    onChange({
      [`question_${question.id}`]: e.currentTarget.value
    })
  }

  render() {
    const {question} = this.props

    return (
      <div className="single-choice">
        {question.single_choice.map(({answer}, index) => {
          return (
            <span key={`answer-${question.id}-${index}`}>
              <input
                id={`answer-${question.id}-${index}`}
                type="radio"
                name="answer"
                value={answer}
                onChange={e => this._handleChange(e)}
              />
              <label htmlFor={`answer-${question.id}-${index}`}>{answer}</label>
            </span>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Feedback/SingleChoice/index.js